import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { DialogDataService } from '../../dialog/dialog-data.service';
import { AlertService } from '../../shared/services/alert.service';
import { FileDownloadService } from '../../shared/services/file-download.service';
import { EmailService } from '../email.service';
import { EmailAttachment, EmailMessage, EmailResponse } from '../email.type';

@Component({
    selector: 'app-email-view',
    templateUrl: './email-view.component.html',
    styleUrls: ['./email-view.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class EmailViewComponent implements OnInit {
    @Input() email: EmailMessage;
    @Input() domainClass: string;
    @Input() domainId: number | bigint;
    @Input() mayResend: boolean;
    @Input() mayViewBcc: boolean;
    @Output() emailResentEvent: EventEmitter<EmailMessage> = new EventEmitter<EmailMessage>();
    loading: boolean;

    constructor(
        private dialogData: DialogDataService<EmailResponse>,
        private service: EmailService,
        private fileDownload: FileDownloadService,
        private alert: AlertService
    ) {
        if (dialogData && dialogData?.data?.emailMessage) {
            this.email = dialogData.data.emailMessage;
        }
    }

    ngOnInit(): void {}

    downloadAttachment(attach: EmailAttachment) {
        this.loading = true;
        this.alert.toastSuccess(`Downloading ${attach.name}`);
        this.service.downloadAttachment(attach.id).subscribe({
            next: (value) => {
                this.fileDownload.downloadFile(value);
                this.loading = false;
            },
            error: (error) => {
                this.alert.toastErrorObject(error);
                this.loading = false;
            }
        });
    }

    resend() {
        this.loading = true;
        this.alert.confirm({
            title: 'Resend email?',
            text: 'Are you sure you want to resend this email?',
            callBack: {
                this: this,
                function: (result: boolean) => {
                    if (result === true) {
                        this.service.resend(this.email.id, this.domainClass, this.domainId).subscribe({
                            next: (e) => {
                                this.loading = false;
                                this.alert.toastSuccess('Message resent.');
                                this.emailResentEvent.emit(e);
                            },
                            error: (err) => {
                                this.loading = false;
                                this.alert.toastErrorObject(err);
                            }
                        });
                    } else {
                        this.loading = false;
                    }
                }
            }
        })
    }
}
